import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { CssBaseline } from "@mui/material";
import EnrollFormFrame from "./EnrollFormFrame";
import HeroSection from "../../elements/HeroSection";

const EnrollPage: React.FC = () => {
  const { t } = useTranslation();

  const formRef = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CssBaseline />
      <HeroSection
        mainTitle={<>{t("EnrollPage.mainTitle")}</>}
        secondaryTitle={<>{t("EnrollPage.secondaryTitle")}</>}
        backgroundImageUrl={"/enrollPage/hero.webp"}
        altImage={t("AltImages.alt_image_enroll")}
        buttonText={t("EnrollPage.buttonText")}
        formRef={formRef}
      />
      <EnrollFormFrame formRef={formRef} />
    </>
  );
};

export default EnrollPage;
